module.exports = __webpack_public_path__ + "img/66.e3481960.jpg";